import { render } from "./UniversitiesView.vue?vue&type=template&id=ccdadd9e&scoped=true"
import script from "./UniversitiesView.vue?vue&type=script&lang=js"
export * from "./UniversitiesView.vue?vue&type=script&lang=js"

import "./UniversitiesView.vue?vue&type=style&index=0&id=ccdadd9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdadd9e"]])

export default __exports__